/* eslint-disable prettier/prettier */
import { DashboardData } from '../types/dashboard';
import { UpcomingSession, UpcomingSessionCount } from '../types/dashboard';
import { apiService } from './api.service'; // Your generic API service
import { ApiResponse } from '../types/index'; // Your type definitions

class DashboardService {
	/**
     * Fetches the dashboard summary from the API.
     @returns {Promise<DashboardData | null>} The dashboard data on success, or null on failure.
     */
	async getDashboardSummary(): Promise<DashboardData | null> {
		try {
			// Your apiService's get method returns the full ApiResponse
			const response =
				await apiService.get<DashboardData>('dashboard/summary');

			// Explicitly check the success flag from the response body
			if (!response.success) {
				// Throw an error if the API indicates failure
				throw new Error(
					response.message || 'Failed to fetch dashboard summary.'
				);
			}

			// On success, return the nested 'data' object
			console.log('API response data:', response.data);
			return response.data;
		} catch (error) {
			console.error('Error fetching dashboard summary:', error);
			// In case of an exception, we return null to the hook,
			// which will then set its error state.
			throw error; // Re-throwing allows the hook to catch it and set an error message.
		}
	}

// 	async getUpcomingSessions(
// 	limit: number = 5
// ): Promise<UpcomingSession[]> {
// 	try {
// 		const response = await apiService.get<UpcomingSession[]>(
// 			`dashboard/upcoming?limit=${limit}`
// 		);

// 		if (!response.success) {
// 			throw new Error(
// 				response.message || 'Failed to fetch upcoming sessions.'
// 			);
// 		}

// 		return response.data;
// 	} catch (error) {
// 		console.error('Error fetching upcoming sessions:', error);
// 		throw error;
// 	}
// }
// }
async getUpcomingSessions(
	limit: number = 5
): Promise<UpcomingSessionCount[]> {
	const response = await apiService.get<UpcomingSessionCount[]>(
		`dashboard/upcoming?limit=${limit}`
	);

	return response.data;
}}

export const dashboardService = new DashboardService();
